import script from "./BotsMessengerBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./BotsMessengerBlock.vue?vue&type=script&setup=true&lang=js"

import "./BotsMessengerBlock.vue?vue&type=style&index=0&id=3748674a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3748674a"]])

export default __exports__